import { Trash2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

var API = "/api";

function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  var d = new Date(dateStr);
  return d.toLocaleDateString() + " " + d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
}

export default function NotificationsTab({ notifications, onRefresh }) {
  function handleDelete(notificationId) {
    axios.delete(API + "/notifications/" + notificationId)
      .then(function() { toast.success("Notification removed"); onRefresh(); })
      .catch(function() { toast.error("Failed to delete"); });
  }

  return (
    <div className="bg-[#121212] border border-white/5 rounded-sm overflow-hidden">
      <div className="p-4 border-b border-white/10">
        <h3 className="font-heading font-bold text-white">Back-in-Stock Notification Subscribers</h3>
        <p className="text-[#71717a] text-sm">Customers waiting for products to be restocked. Notifications are sent automatically when you update quantity from 0 to any positive number.</p>
      </div>
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Product</th>
            <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Email</th>
            <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Status</th>
            <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Date</th>
            <th className="text-right p-4 font-mono text-xs text-[#A1A1AA] uppercase">Actions</th>
          </tr>
        </thead>
        <tbody>
          {notifications.map(function(notif) {
            return (
              <tr key={notif.id} className="border-b border-white/5 hover:bg-white/5">
                <td className="p-4 text-white">{notif.product_name}</td>
                <td className="p-4 text-[#A1A1AA]">{notif.email}</td>
                <td className="p-4">
                  {notif.notified ? (
                    <span className="text-[#8CB369] text-sm">Notified</span>
                  ) : (
                    <span className="text-yellow-400 text-sm">Waiting</span>
                  )}
                </td>
                <td className="p-4 text-[#71717a] text-sm">{formatDate(notif.created_at)}</td>
                <td className="p-4 text-right">
                  <button onClick={function() { handleDelete(notif.id); }} className="p-2 text-[#A1A1AA] hover:text-red-400">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            );
          })}
          {notifications.length === 0 && (
            <tr><td colSpan="5" className="p-8 text-center text-[#71717a]">No notification subscribers yet</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
